/* CE · Kopf – misst die Kopfhöhe (--hd-h) und die Höhe der Ankündigungsleiste (--ank-h)
   und schaltet den durchsichtigen Kopf über einem Startbild im Stil „Vollbild-Foto“
   beim Scrollen auf hell (.ist-fest).
   Ohne JavaScript bleibt der Kopf hell (die CSS-Regeln greifen nur mit .ce-js). */
(function () {
  var root = document.documentElement;
  var lauf = false;

  function kopf() { return document.querySelector('.ce-hd'); }
  function held() { return document.querySelector('main > .shopify-section:first-child .ce-held'); }

  function messen() {
    var a = document.querySelector('.ce-sektion-ankuendigung');
    root.style.setProperty('--ank-h', (a && !a.hidden ? a.offsetHeight : 0) + 'px');
    var k = kopf(); if (!k) return;
    var bar = k.querySelector('.ce-hd2__bar') || k;
    root.style.setProperty('--hd-h', bar.offsetHeight + 'px');
  }

  function pruefen() {
    lauf = false;
    var k = kopf(); if (!k || !k.classList.contains('ce-hd--klar')) return;
    var h = held();
    if (!h) { k.classList.add('ist-fest'); return; }
    var fest = h.getBoundingClientRect().bottom <= k.getBoundingClientRect().bottom + 40;
    k.classList.toggle('ist-fest', fest);
  }

  function start() {
    messen(); pruefen();
    var k = kopf();
    if (k && 'ResizeObserver' in window) {
      new ResizeObserver(messen).observe(k.querySelector('.ce-hd2__bar') || k);
    }
  }

  addEventListener('scroll', function () { if (!lauf) { lauf = true; requestAnimationFrame(pruefen); } }, { passive: true });
  addEventListener('resize', function () { messen(); pruefen(); });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.ce-ank__zu')) setTimeout(messen, 0); });
  document.addEventListener('shopify:section:load', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
